var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticStyle:{"color":"#E16531"}},[_vm._v("欢迎您使用智慧停车商家管理系统")])])
}]

export { render, staticRenderFns }